/** Localization resource row from IMS Resources API. */
export interface ResourceDto {
  culture: string;
  /** Display alias mapped from API `name`. */
  labelName: string;
  value: string;
  description: string;
  /** API field / path key. */
  name?: string;
}

/**
 * Payload for POST / PUT `/ims/api/Resources` and POST `/bulk`.
 * UI shows “Label Name”; API property is `name`.
 */
export interface SaveResourceRequest {
  culture: string;
  name: string;
  value: string;
  description: string;
}

/** Payload for range create — POST `/ims/api/Resources/bulk`. */
export type SaveResourceRangeRequest = SaveResourceRequest[];

export interface ResourceApiResponse<T> {
  data?: T;
  message?: string;
  succeeded?: boolean;
  success?: boolean;
}

/** Prefer `labelName`; fall back to API `name`. */
export function resourceLabelName(item: Pick<ResourceDto, 'labelName' | 'name'>): string {
  return String(item.labelName ?? item.name ?? '').trim();
}

/** GET `/ims/api/Resources` query params. */
export interface ResourceQueryParams {
  search?: string | null;
}
